<form id="adjustStartTimeForm" [formGroup]="adjustStartTimeForm" autocomplete="off">
  <div class="form-group col-md-12">
    <label class="control-label required">{{'i18n.domain.parker-registration.adjust-parker-registration-dialog.function-forms.startTime' | translate}}</label>
    <ejs-datetimepicker id="startTime" formControlName="startTime"
                        timeFormat="HH:mm"
                        format="dd.MM.yyyy HH:mm"
                        [max]="maxDate">
    </ejs-datetimepicker>
    <app-error-messages [control]="adjustStartTimeForm.controls.startTime"></app-error-messages>
  </div>
</form>
